import React from 'react';

//WARNING: do not wrapp withStyles HOC as displayName will not be preserved
// const Side = ({ children, theme }) => {
//   return(
//     <div style={{position: "fixed", zIndex: 9999, marginLeft: theme.spacing.unit*4}}>
//       {children}
//     </div>
//   );
// };
const Side = ({ children, theme }) => {
  return(
    <div>
      {children}
    </div>
  );
};

Side.displayName ="Side";

export default Side;



// WEBPACK FOOTER //
// ./src/components/admin/ContentEdit/Side.jsx